/* unplugin-vue-components disabled */import { render } from "./send-button.vue?vue&type=template&id=2a8f3ead&scoped=true"
import script from "./send-button.vue?vue&type=script&lang=js"
export * from "./send-button.vue?vue&type=script&lang=js"

import "./send-button.vue?vue&type=style&index=0&id=2a8f3ead&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8f3ead"],['__file',"src/components/chat-input/send-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a8f3ead"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a8f3ead', __exports__)) {
    api.reload('2a8f3ead', __exports__)
  }
  
  module.hot.accept("./send-button.vue?vue&type=template&id=2a8f3ead&scoped=true", () => {
    api.rerender('2a8f3ead', render)
  })

}


export default __exports__